var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-with-title"},[_c('animated-title')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }